import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import Stylesheet from './Selector.module.css';
import {firestore} from '@enigma/core/services';
import Loading from '../../../../components/Spinner/Standard/Standard';
import Classnames from 'classnames';
import { ico_search } from '../../../../icon';
import Input from '../../../../elements/Input/Input';

const Selector = (props) => {
    const collection = props.collection;
    const group = props.group;
    const [metadata, setMetadata] = useState(null);
    const [selected, setSelected] = useState(props?.defaultValue || null);
    const [records, setRecords] = useState([]);
    const [results, setResults] = useState([]);
    
    useEffect(() => {
        // fetch group metadata
        firestore.doc(`${collection}/${group}`).get()
        .then(snap => setMetadata({...snap.data(), id: snap.id}))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props])

    useEffect(() => {
        if (!metadata) return;
        // get group records
        firestore.doc(`${collection}/${group}`)
        .collection('records').get()
        .then(snap => {
            let collection = [];
            for (const record of snap.docs)
                collection.push({...record.data(), id: record.id})
            setRecords(collection);
        })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [metadata]);

    const toggleRecord = recordID => {
        let current = selected;
        const record = records.find(({id}) => id === recordID);
        if (recordID === selected) current = null;
        else {
            // find the first unique column and set as value
            let columnFound = false;
            for (const schema of metadata.schema) {
                if (schema?.unique) {
                    columnFound = true;
                    current = record[schema.name];
                    break;
                }
            }
            if (!columnFound) current = recordID;
        }
        setSelected(current)
        if (props?.onChange) props.onChange(current)
    }

    const isSelected = recordID => {
        if (!selected) return null;
        const record = records.find(({id}) => id === recordID);
        // check if id is set as refference value
        if (record.id === selected) return true;
        // check if a unique column is set as refference value
        for (const schema of metadata.schema) {
            if (schema?.unique && record[schema.name] === selected) {
                return true;
            }
        }
        // not selected
        return false;
    }

    const value = (column, record) => {
        switch (column.type) {
            case "primaryKey":
                return record.id;
            case "user":
                return record.author;
            case "timestamp":
                return new Date(record.timestamp).toDateString();
            case "date" :
            case "notify":
                return new Date(record[column.name] || Date.now()).toDateString();
            case "file":
                return record[column.name]?.name || column.default || "NAN";
            case "table refference":
            case "form refference":
                return record[column.name]?.join(',') || "NAN";
            default:
                return record[column.name] || column.default || "NAN";
        }
    }

    const search = (value) => {
        if (value && value !== "") {
            let columns = metadata.schema;
            for (const record of records) {
                // match selected columns
                for (const column of columns) {
                    const columnName = column.name || column;
                    let columnValue = record[columnName];
                    // identify column type
                    const schema = metadata?.schema?.find(({name}) => name === columnName);
                    if (!schema) {
                        if (columnName === "id") columnValue = record['id'];
                        if (columnName === "author") columnValue = record['author'];
                        if (columnName === "timestamp") columnValue = new Date(record['timestamp']).toDateString();
                    } else if (schema.type === "file" && record[columnName]?.name)
                        columnValue = record[columnName].name;
                    else if (schema.type === "date" && !isNaN(new Date(record[columnName]))) {
                        const date = new Date(record[columnName])
                        const year = date.getUTCFullYear();
                        const month = date.getUTCMonth() < 10 
                        ? "0"+(date.getUTCMonth()+1)
                        : (date.getUTCMonth()+1);
                        const day = date.getDate()< 10 
                        ? "0"+date.getDate() 
                        : date.getDate();
                        columnValue = `${year}/${month}/${day}`;
                    }
                    const searchTerm = `${value}`.replaceAll(/[\\()]/g, "");
                    // match search term to column value
                    if (`${columnValue}`.toLowerCase().search(searchTerm) > -1)
                        results.push(record);
                }
            }
            // recrod has no match to search term
            return null;
        } else setResults([]);
    }

    const content = _ => {
        if (!metadata) {
            return (
                <div className={Stylesheet.Loading}>
                    <Loading show={true} />
                </div>
            )
        }
        return (
            <React.Fragment>
                <div className={Stylesheet.Search}>
                    <Input placeholder="search records" 
                    onChange={value => search(value)} 
                    icon={ico_search} />
                </div>
                <div className={Stylesheet.Table}>
                    <div className={Stylesheet.Columns}>
                        <h5>id</h5>
                        {metadata.schema.map((value, index) => (
                            <h5 key={index}>{value.title}</h5>
                        ))}
                        <h5>branch</h5>
                        <h5>author</h5>
                        <h5>date created</h5>
                    </div>
                    <div className={Stylesheet.Records}>
                        {records.map((record, index) => (
                            <div className={Classnames(Stylesheet.Record,{
                                [Stylesheet['Active']]: isSelected(record.id)
                            })} key={index} onClick={_ => toggleRecord(record.id)}>
                                <h5>{record.id}</h5>
                                {metadata.schema.map((column, columnIndex) => (
                                    <h5 key={columnIndex}>{value(column, record)}</h5>
                                ))}
                                <h5>{record.branch}</h5>
                                <h5>{record.author}</h5>
                                <h5>{new Date(record.timestamp).toDateString()}</h5>
                            </div>
                        ))}
                    </div>
                </div>
            </React.Fragment>
        )
    }

    return (
        <div className={Stylesheet.Container}>
            {content()}
        </div>
    )
}

export default Selector;